import type {GreenhouseJobsQuery} from '@/graphql-types'

export type GreenhouseListingType = GreenhouseJobsQuery['allGreenhouseJob']['nodes']

export const getJobsByDepartment = (listings: GreenhouseListingType) => {
    const jobsByDepartment: Record<string, typeof listings> = {}

    for (const listing of listings) {
        const department = listing.departments[0]?.name

        if (!department) {
            continue
        }

        if (!jobsByDepartment[department]) {
            jobsByDepartment[department] = []
        }

        jobsByDepartment[department].push(listing)
    }

    return jobsByDepartment
}
